import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { Button } from "@vds/buttons";
import styled from "styled-components";
import { APPEARANCE_TEXT } from "../../../constants/enrolledAppearanceConstants";

const ModalContent = styled.div`
  padding: 20px 0;
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 24px;
`;

const StyledButton = styled(Button)`
  width: 226px;
`;

const DeleteConfirmationModal = ({ opened, onClose, onConfirm, appearanceName, loading }) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      width="500px"
      data-testid="delete-confirmation-modal"
    >
      
      <ModalContent>
         <div style={{ marginBottom: "30px" }}>
          <Title size="large" bold data-testid="delete-confirmation-title">
            {APPEARANCE_TEXT.DELETE_CONFIRMATION_TITLE}
          </Title>
        </div>
        {appearanceName && (<Body size="large" viewport="desktop" data-testid="delete-confirmation-message">
          {`${APPEARANCE_TEXT.DELETE_CONFIRMATION_MESSAGE}${appearanceName}?`}
        </Body>)}
        <ModalActions>
          <StyledButton
            use="primary"
            onClick={onConfirm}
            disabled={loading}
            data-testid="confirm-delete-button"
          >
            {loading ? "Deleting..." : APPEARANCE_TEXT.DELETE_BUTTON}
          </StyledButton>
          <StyledButton
            use="secondary"
            onClick={onClose}
            disabled={loading}
            data-testid="cancel-delete-button"
          >
            {APPEARANCE_TEXT.CANCEL_BUTTON}
          </StyledButton>
        </ModalActions>
      </ModalContent>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  appearanceName: PropTypes.string,
  loading: PropTypes.bool,
};

DeleteConfirmationModal.defaultProps = {
  appearanceName: "",
  loading: false,
};

export default DeleteConfirmationModal;
